// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__95Rh8","checkbox-span":"checkbox_checkbox-span__Ci4uR","checked":"checkbox_checked__8beil"};